import { render, staticRenderFns } from "./GenericErrorModal.vue?vue&type=template&id=2c37fbae&scoped=true"
import script from "./GenericErrorModal.vue?vue&type=script&lang=js"
export * from "./GenericErrorModal.vue?vue&type=script&lang=js"
import style0 from "./GenericErrorModal.vue?vue&type=style&index=0&id=2c37fbae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c37fbae",
  null
  
)

export default component.exports